module.exports = __webpack_public_path__ + "static/media/ibd_neck2.40199507.png";